import { render } from "./Information.vue?vue&type=template&id=1b84239e&scoped=true"
import script from "./Information.vue?vue&type=script&lang=js"
export * from "./Information.vue?vue&type=script&lang=js"

import "./Information.vue?vue&type=style&index=0&id=1b84239e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b84239e"

export default script